/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@folio/stripes-components';
import SubInstanceGroup from '@folio/inventory/src/Instance/InstanceDetails/SubInstanceGroup';

function InstanceRelationshipFieldView({ fieldValues, data, fieldLabel }) {
  const { name } = fieldValues;
  const titleKey =
    name === 'subInstanceId' ? 'subInstanceId' : 'superInstanceId';
  const id = name === 'subInstanceId' ? 'childInstances' : 'parentInstances';

  return (
    <Row>
      <Col xs={12}>
        <SubInstanceGroup
          id={id}
          titleKey={titleKey}
          label={fieldLabel}
          titles={data}
        />
      </Col>
    </Row>
  );
}

InstanceRelationshipFieldView.propTypes = {
  fieldValues: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object),
  fieldLabel: PropTypes.string,
};

export default InstanceRelationshipFieldView;
